module.exports = __webpack_public_path__ + "static/media/doctorImage.d1d33ba9.png";